<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

export default {
    props: {
        prop_edit: { default: true }
    },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            balance: 0,
            loading_balance: false,
            loading_companies: false,

            users: [],
            companies: [],

            form: {
                user_id: '',
                company_id: '',
                bank_id: '',
                amount: '',
                payment_method: '',
                description: '',
                _method: 'POST',
            }
        }
    },
    methods: {

        closedModal() {
            this.errors = {};
            this.balance = 0;
            this.loading_balance = false;
            this.loading_companies = false;

            this.companies = [];

            this.form.user_id = '';
            this.form.company_id = '';
            this.form.bank_id = '';
            this.form.amount = '';
            this.form.payment_method = '';
            this.form.description = '';

            this.$modal.hide('walletRecharge');
        },

        async loadUsers() {
            try {
                let _endpoint = '/wallets/users';
                let { data } = await request.get(_endpoint);
                this.users = data.users || [];
            } catch (error) {
                console.log(error);
                this.users = [];
            }
        },

        async onChangeUser() {
            this.errors = {};
            this.balance = 0;
            this.form.company_id = '';
            this.form.bank_id = '';
            this.companies = [];

            if (!this.form.user_id) return;

            await this.loadCompaniesByUser();
        },

        async loadCompaniesByUser() {
            try {
                this.loading_companies = true;

                let _endpoint = '/wallets/user-companies';
                let { data } = await request.get(_endpoint, {
                    params: { user_id: this.form.user_id }
                });

                this.companies = data.companies || [];
            } catch (error) {
                console.log(error);
                this.companies = [];
            } finally {
                this.loading_companies = false;
            }
        },

        async onChangeCompany() {
            this.errors = {};
            this.balance = 0;
            this.form.bank_id = '';

            if (!this.form.user_id || !this.form.company_id) return;

            await this.catalogue.getBankAccountCompany(this.form.company_id);
        },

        async onChangeBankAccountCompany() {
            this.errors = {};
            this.balance = 0;

            if (!this.form.user_id || !this.form.company_id || !this.form.bank_id) return;

            await this.getBalance();
        },

        async getBalance() {
            try {
                this.loading_balance = true;

                let _endpoint = '/wallets/balance';
                let { data } = await request.get(_endpoint, {
                    user_id: this.form.user_id,
                    company_id: this.form.company_id,
                    bank_id: this.form.bank_id

                });

                this.balance = data.balance || 0;

            } catch (error) {
                console.log(error);
                this.balance = 0;
            } finally {
                this.loading_balance = false;
            }
        },

        async saveWalletRecharge() {
            try {
                this.errors = {};

                let _endpoint = '/wallet-transactions';

                let payload = {
                    user_id: this.form.user_id,
                    company_id: this.form.company_id,
                    bank_id: this.form.bank_id,
                    amount: this.form.amount,
                    payment_method: this.form.payment_method,
                    description: this.form.description,
                };

                let { data } = await request.post(_endpoint, payload);

                if (data) {
                    this.successNotification(data.message || 'Se ha registrado la recarga con éxito.');
                    this.balance = data.balance_after != null ? data.balance_after : this.balance;

                    this.form.amount = '';
                    this.form.description = '';

                    Event.$emit('event-load-wallet-transactions');
                }

            } catch (error) {
                this.errors = {};
                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },

        formatMoney(value) {
            return Number(value || 0).toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },

        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },
    async mounted() {
        // cargar usuarios
        await this.catalogue.getUsersInvestors();
        await this.catalogue.get_companies_all();
    },
    created() {
        Event.$on("event-show-walletRecharge", async (info) => {

            // precargar si mandas user_id/company_id
            if (info && info.user_id) {
                this.form.user_id = info.user_id;
                await this.loadCompaniesByUser();
            }

            if (info && info.company_id) {
                this.form.company_id = info.company_id;
                await this.getBalance();
            }

            this.$modal.show('walletRecharge');
        });
    },
    computed: {
        ...mapGetters({ 'authUser': 'auth/user' })
    }
}
</script>

<template>
    <modal v-bind:click-to-close="false" name="walletRecharge" :width="'60%'" :scrollable="true" :height="'auto'">
        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()">
            <i class="fa-solid fa-xmark"></i>
        </button>

        <form @submit.prevent="saveWalletRecharge" method="post">
            <div class="modal-header">
                <h5 class="modal-title">Recarga de Monedero</h5>
            </div>

            <div class="modal-body">
                <div class="row">

                    <!-- Usuario -->
                    <div class="col-md-6 mt-3">
                        <label>Usuario</label>
                        <select class="form-control" v-model="form.user_id" @change="onChangeUser">
                            <option value="">Selecciona</option>
                            <option v-for="(u, index) in catalogue.users_investors" :key="index" :value="u.id">
                                {{ u.name }} {{ u.last_name }}
                            </option>
                        </select>
                        <div v-if="errors && errors.user_id" class="text-danger">{{ errors.user_id[0] }}</div>
                    </div>

                    <!-- Empresa -->
                    <div class="col-md-6 mt-3">
                        <label>Compañía</label>
                        <select class="form-control" v-model="form.company_id" @change="onChangeCompany"
                            :disabled="!form.user_id">
                            <option value="">Selecciona</option>
                            <option v-for="(c, index) in catalogue.companies_all" :key="index" :value="c.id">
                                {{ c.name }}
                            </option>
                        </select>

                        <small v-if="loading_companies" class="text-muted">Cargando compañías...</small>
                        <div v-if="errors && errors.company_id" class="text-danger">{{ errors.company_id[0] }}</div>

                        <div class="mt-2">
                            <small v-if="loading_balance" class="text-muted">Consultando saldo...</small>
                        </div>
                    </div>

                    <div class="col-md-6 mt-3">
                        <label>Cuenta bancaria (empresa)</label>
                        <select class="form-control" v-model="form.bank_id"
                            @change="onChangeBankAccountCompany"
                            :disabled="!form.user_id || !form.company_id || loading_bank_accounts">
                            <option value="">Selecciona</option>

                            <!-- Ajusta los campos según tu respuesta real -->
                            <option v-for="(acc, index) in catalogue.bank_account_company" :key="index" :value="acc.id">
                                {{ acc.bank?.name || 'Banco' }} - {{ acc.account_number || acc.number || ('Cuenta #' +
                                acc.id) }}
                            </option>
                        </select>

                        <small v-if="loading_bank_accounts" class="text-muted">Cargando cuentas bancarias...</small>
                        <div v-if="errors && errors.bank_id" class="text-danger">
                            {{ errors.bank_id[0] }}
                        </div>

                        <div class="mt-2">
                            <small v-if="loading_balance" class="text-muted">Consultando saldo...</small>

                            <div v-if="!loading_balance && form.user_id && form.company_id && form.bank_id"
                                class="alert alert-info py-2 mb-0">
                                <strong>Saldo actual:</strong> $ {{ formatMoney(balance) }}
                            </div>
                        </div>
                    </div>

                    <!-- Tipo -->
                    <div class="col-md-6 mt-3">
                        <label>Tipo de movimiento</label>
                        <select class="form-control" v-model="form.payment_method">
                            <option value="">Seleccione</option>
                            <option value="1">Depósito</option>
                            <option value="2">Transferencia</option>
                        </select>
                        <div v-if="errors.payment_method" class="text-danger">{{ errors.payment_method[0] }}</div>
                    </div>

                    <!-- Monto -->
                    <div class="col-md-6 mt-3">
                        <label>Monto</label>
                        <input class="form-control" v-model="form.amount" type="number" step="0.01" min="0">
                        <div v-if="errors && errors.amount" class="text-danger">{{ errors.amount[0] }}</div>

                        <div class="mt-2" v-if="form.amount && form.user_id && form.company_id">
                            <small class="text-muted">
                                Saldo después de recarga:
                                <strong>$ {{ formatMoney(Number(balance) + Number(form.amount || 0)) }}</strong>
                            </small>
                        </div>
                    </div>

                    <!-- Descripción -->
                    <div class="col-md-12 mt-3">
                        <label>Descripción</label>
                        <input class="form-control" v-model="form.description" type="text" maxlength="255">
                        <div v-if="errors && errors.description" class="text-danger">{{ errors.description[0] }}</div>
                    </div>

                    <div class="col-md-12 mt-4">
                        <hr>
                        <button v-if="prop_edit" type="submit" class="btn float-right btn-outline-success"
                            :disabled="!form.user_id || !form.company_id">
                            <i class="fas fa-save"></i> Guardar
                        </button>
                        <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i> Regresar
                        </button>
                    </div>

                </div>
            </div>
        </form>
    </modal>
</template>